import { render, staticRenderFns } from "./GedocProtocolloView.vue?vue&type=template&id=d8d0cac6"
import script from "./GedocProtocolloView.vue?vue&type=script&lang=js"
export * from "./GedocProtocolloView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports